import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { SkeletonCardFields } from 'components/Loading';
import {
    Card,
    CardHeader,
    CardContent,
    Divider,
    Grid,
    FormControlLabel,
    Switch
} from '@material-ui/core';
import { KeyboardTimePicker } from '@material-ui/pickers';
import { convertToMomentFromTime } from 'helpers/timeUtils';

const useStyles = makeStyles(() => ({
    root: {},
    switchContent: {
        paddingTop: '12px'
    }
}));

const ScheduleRules = props => {
    const {
        className,
        staticContext,
        campaign,
        back,
        next,
        showNav,
        ...rest
    } = props;
    const { thisCampaign, isLoading, handleDelayUntilNextDayChange, handleDelayDeliveryTimeChange,
        shouldShowError, getErrorMessage, isCampaignReadOnly } = campaign;
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Card {...rest} className={clsx(classes.root, className)}>
                <form autoComplete="off">
                    <CardHeader
                        title="Schedule Rules"
                        titleTypographyProps={{ variant: 'h1' }}
                    />
                    <Divider />
                    {isLoading &&
                        <CardContent>
                            <Grid container spacing={0}>
                                <SkeletonCardFields />
                            </Grid>
                        </CardContent>}
                    {!isLoading && (
                        <CardContent>
                            <Grid item xs={12}>
                                <Grid item md={6} xs={12}>
                                    <KeyboardTimePicker
                                        ampm={false}
                                        openTo="hours"
                                        views={["hours", "minutes", "seconds"]}
                                        format="HH:mm:ss"
                                        label="Delay delivery time"
                                        value={thisCampaign?.scheduleRule?.delayDeliveryTime ?
                                            convertToMomentFromTime(thisCampaign?.scheduleRule?.delayDeliveryTime) :
                                            null}
                                        onChange={(event) => handleDelayDeliveryTimeChange(event)}
                                        error={shouldShowError(`scheduleRule.delayDeliveryTime`)}
                                        helperText={getErrorMessage(`scheduleRule.delayDeliveryTime`)}
                                        disabled={isCampaignReadOnly()}
                                    />
                                </Grid>
                                <Grid item md={6} xs={12} className={classes.switchContent}>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={thisCampaign?.scheduleRule?.delayUntilNextDay}
                                                name="delayUntilNextDay"
                                                onChange={handleDelayUntilNextDayChange}
                                                color="primary"
                                                inputProps={{ 'aria-label': 'primary checkbox' }}
                                                disabled={isCampaignReadOnly()}
                                            />
                                        }
                                        label="Delay delivery time until next day"
                                    />
                                </Grid>
                            </Grid>
                        </CardContent>
                    )}
                </form>
            </Card>
        </div>
    );
};

export default ScheduleRules;
